/* src/app/recalculate-transactions/settings-presenter/settings-presenter.component.scss */
body#themeTag :host ::ng-deep .p-toolbar.p-component {
  height: 53.8px !important;
}
/*# sourceMappingURL=settings-presenter.component.css.map */
